<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" *ngIf="loadAPIcall && viewedList?.length==0">
  <app-common-skeleton [countforView]="10" [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
</div>

<div class="sub-entities-scroll-container" *ngIf="viewedList.length > 0; else noResult" infiniteScroll
  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" [scrollWindow]="false" [alwaysCallback]="true"
  (scrolled)="onScrollDown()">
  <div class="hpanel" *ngFor="let items of viewedList">
    <div class="panel-body border-radius-top-left-right-6" [ngClass]="{'disabled':candidateDetails?.status !='ACTIVE'}">
      <div class="row">
        <div class="col-sm-8">
          <div class="view-card">

            <img *ngIf="items?.logo" class="img-circle m-r-4" [src]="items?.logo">
            <div *ngIf="!items.logo">
              <div class="circles" [style.background-color]="getColortwo(items?.firstName, items?.lastName)">
                <div class="circle-text" [style.color]="getTextColor(items?.firstName, items?.lastName)">{{
                  getInitialstwo(items?.firstName, items?.lastName) }}</div>
              </div>
            </div>

            <div class="details-grid">
              <div class="view-name">
                <h6 class="fw-bold">
                  {{items.firstName}} {{" "}} {{items.lastName}}
                </h6>
              </div>
              <div class="view-title">
                <span *ngIf="items.UserType == 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
                <span *ngIf="items.UserType == 'RECRUITER'">Recruiter</span>
                <span *ngIf="items.UserType == 'JOB_SEEKER'">Job Seeker</span>
                <span *ngIf="items.UserType == 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
                <span *ngIf="items.UserType == 'BENCH_RECRUITER'">Bench Recruiter</span>
                <span *ngIf="items.organisation"> &#64;</span> {{items.organisation}}
              </div>
              <div class="view-time">
                <span>Viewed at {{items.activityDate| timezoneDate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4 chaticon" *ngIf="LoginUserId!=items.userId">
          <div id="candidate_viewed_chat_button" class="chat-button" title="{{items?.nonSeenMessageCount}} Messages"
           (click)="chatuser(items, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="blue-color">{{items?.nonSeenMessageCount}}</span>
            <span>Chat</span>
          </div>
        </div>
      </div>
      <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length>0" [countforView]="5"
        [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    </div>
  </div>
  <div class="gs-end-of-list" *ngIf="stopscrollFlag && viewedList.length>0">
    <div class="wert">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
      <div class="col-md-12">
        <p class="font-16">You've reached the bottom of the page</p>
      </div>
    </div>
  </div>
</div>
<ng-template #noResult>
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
      <ng-icon name="tablerZoomQuestion"></ng-icon>
    </div>
    <div class="col-md-12 fig">No views yet. </div>
  </div>
</ng-template>
</ng-container>

<!-- ═══════════════════════════════════════════
     V3 DESIGN — Candidate Views
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires.
       The #scrollSentinel IntersectionObserver stays as a second trigger
       into the same guarded onScrollDown(). -->
    <div infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="200"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()">
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length === 0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <!-- Click on avatar / name / info area routes to the viewer's
         public profile. Matches /newjobs Views/Likes behavior so both
         sides are symmetric.
         AUDIT_04 Batch 4 — `disabled` class dims the row when the
         viewed candidate is no longer ACTIVE (parity with V2 `:8`). -->
    <div class="jc-v3-person-item" *ngFor="let items of viewedList"
         [ngClass]="{'disabled': candidateDetails?.status !== 'ACTIVE'}">
      <img *ngIf="items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [src]="items.logo" alt="avatar"
        (click)="profile(items.userId)"
        (error)="$any($event.target).style.display='none'">
      <div *ngIf="!items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [style.background-color]="getColortwo(items?.firstName, items?.lastName)"
        [style.color]="getTextColor(items?.firstName, items?.lastName)"
        (click)="profile(items.userId)">
        {{ getInitialstwo(items?.firstName, items?.lastName) }}
      </div>
      <div class="jc-v3-p-info jc-v3-p-clickable" (click)="profile(items.userId)">
        <div class="jc-v3-p-name">{{ items?.firstName }} {{ items?.lastName }}</div>
        <div class="jc-v3-p-role">
          <span *ngIf="items.UserType == 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
          <span *ngIf="items.UserType == 'RECRUITER'">Recruiter</span>
          <span *ngIf="items.UserType == 'JOB_SEEKER'">Job Seeker</span>
          <span *ngIf="items.UserType == 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
          <span *ngIf="items.UserType == 'BENCH_RECRUITER'">Bench Recruiter</span>
          <span *ngIf="items?.organisation"> &middot; {{ items.organisation }}</span>
        </div>
      </div>
      <div class="jc-v3-p-time">{{ items?.activityDate | timezoneDate }}</div>
      <button type="button" class="jc-v3-p-chat"
        *ngIf="LoginUserId != items.userId"
       
        (click)="chatuser(items, connectionTemplate); $event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        <span class="jc-v3-p-chat-count" *ngIf="items?.nonSeenMessageCount > 0">{{ items.nonSeenMessageCount }}</span>
        <span>Chat</span>
      </button>
    </div>
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length > 0" [countforView]="2"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <div *ngIf="stopscrollFlag && viewedList?.length > 0" class="jc-v3-list-done">
      <ng-icon name="tablerCircleCheck"></ng-icon>
      <p>You've reached the bottom of the page</p>
    </div>
    <div *ngIf="!loadAPIcall && viewedList?.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <ellipse cx="100" cy="90" rx="46" ry="28" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
        <circle cx="100" cy="90" r="14" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <circle cx="100" cy="90" r="7" fill="#DDD6FE"/>
        <circle cx="100" cy="90" r="3" fill="#7C3AED"/>
        <line x1="60" y1="78" x2="54" y2="72" stroke="#C4B5FD" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="140" y1="78" x2="146" y2="72" stroke="#C4B5FD" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="148" cy="128" r="16" fill="#7C3AED" opacity="0.10"/>
        <circle cx="148" cy="128" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <path d="M143 128 a5 5 0 0 1 10 0 a5 5 0 0 1 -10 0" fill="none" stroke="#7C3AED" stroke-width="1.8"/>
        <circle cx="148" cy="128" r="2.5" fill="#7C3AED"/>
        <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
      </svg>
      <h3>No Views Yet</h3>
      <p>Recruiters who view this candidate will appear here.</p>
    </div>
     <div #scrollSentinel style="height:1px;"></div>
  </div>
</ng-container>

<ng-template #connectionTemplate>
  <app-connection-template [page]="'job-card-1'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values"></app-connection-template>
</ng-template>


<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>